/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Admin_OnlyInputs */

const cs_settings_office_admin_only = /** @type {(inputs: Settings_Office_Admin_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavení kanceláře je dostupné pouze administrátorům.`)
};

const en_settings_office_admin_only = /** @type {(inputs: Settings_Office_Admin_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office settings are available to admins only.`)
};

/**
* | output |
* | --- |
* | "Office settings are available to admins only." |
*
* @param {Settings_Office_Admin_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_admin_only = /** @type {((inputs?: Settings_Office_Admin_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Admin_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_admin_only(inputs)
	return cs_settings_office_admin_only(inputs)
});